import { useEffect, useState } from 'react';

import { useI18n } from '@pega/cosmos-react-core';
import type { PopoverProps } from '@pega/cosmos-react-core';

import Popover from './Popover';
import { mockQuery } from './mockData';
import type { MockRawItem } from './mockData';

interface ItemConfigProps {
  itemId: MockRawItem['id'];
  target: NonNullable<PopoverProps['target']>;
  onCancel: () => void;
  onSubmit: () => void;
}

const ItemConfig = ({ itemId, target, onCancel, onSubmit }: ItemConfigProps) => {
  const [item, setItem] = useState<MockRawItem | null>(null);
  const [loading, setLoading] = useState(true);
  const t = useI18n();

  useEffect(() => {
    (async () => {
      const [ci] = await mockQuery({ id: itemId, delay: 500 });
      setItem(ci);
      setLoading(false);
    })();
  }, []);

  return (
    <Popover
      loading={loading}
      target={target}
      heading={!loading && item ? item.label : t('loading')}
      onCancel={onCancel}
      onSubmit={onSubmit}
    >
      <div style={{ margin: 'auto' }}>Configuration for {item?.label}...</div>
    </Popover>
  );
};

export default ItemConfig;
